import React from 'react';
import Hero from '../Hero';
import AboutSection from '../Section/AboutSection';
import BrandsSection from '../Section/BrandsSection';
import Banner from '../Section/BannerSection';
import Section from '../Section';
import FeaturesSection from '../Section/FeaturesSection';
import TestimonialSection from '../Section/TestimonialSection';
import BlogSection from '../Section/BlogSection';
import AppointmentSection from '../Section/AppointmentSection';
import FaqSection from '../Section/FaqSection';
import AwardSection from '../Section/AwardSection';
import DepartmentSection from '../Section/DepartmentSection';
import { pageTitle } from '../../helpers/PageTitle';
import { Link } from 'react-router-dom';

const featureListData = [
  {
    iconSrc: '/images/home_1/compassion.svg',
    title: 'Compassion',
    subTitle:
      'We understand that seeking medical care can be a stressful and emotional experience, and we strive to create a welcoming and supportive environment that puts our patients at ease and every one.',
  },
  {
    iconSrc: '/images/home_1/excellence.svg',
    title: 'Excellence',
    subTitle:
      'We are committed to providing excellent medical care and services to our patients. We believe in continuously improving our skills, knowledge, and resources to ensure that we deliver the highest quality care possible.',
  },
  {
    iconSrc: '/images/home_1/integrity.svg',
    title: 'Integrity',
    subTitle: `We believe in practicing medicine with integrity and honesty. We are transparent in our communication and decision-making processes, and we always put our patient's interests first & provide best solution.`,
  },
  {
    iconSrc: '/images/home_1/respect.svg',
    title: 'Respect',
    subTitle:
      'We treat all individuals with respect and dignity, regardless of their background, beliefs, or circumstances. We believe that every person deserves to be treated with compassion and kindness.',
  },
  {
    iconSrc: '/images/home_1/teamwork.svg',
    title: 'Teamwork',
    subTitle:
      'We believe in working collaboratively with our team membersvand other healthcare professionals to provide comprehensive and effective care to our patients.',
  },
];
const brandData = [
  { imgUrl: 'images/brand_1.png', imgAlt: 'Brand' },
  { imgUrl: 'images/brand_2.png', imgAlt: 'Brand' },
  { imgUrl: 'images/brand_3.png', imgAlt: 'Brand' },
  { imgUrl: 'images/brand_4.png', imgAlt: 'Brand' },
  { imgUrl: 'images/brand_5.png', imgAlt: 'Brand' },
  { imgUrl: 'images/brand_6.png', imgAlt: 'Brand' },
  { imgUrl: 'images/brand_7.png', imgAlt: 'Brand' },
  { imgUrl: 'images/brand_8.png', imgAlt: 'Brand' },
];
const faqData = [
  {
    title: 'What type of medicines do you manufacture?',
    content:
      'We produce a wide range of medicines, including tablets, capsules, syrups, ointments, and custom formulations.',
  },
  {
    title: 'Can you create custom formulations for my needs?',
    content:
      'Yes! We specialize in custom formulation development to meet specific client and market requirements.',
  },
  {
    title: 'How do you ensure the quality of your medicines?',
    content:
      'Our state-of-the-art facility follows strict quality control measures, adhering to international safety and compliance standards.',
  },
  {
    title: 'Do you offer contract manufacturing services?',
    content:
      'Absolutely! We partner with businesses to provide contract manufacturing solutions for their Nutraceutical needs.',
  },
  {
    title: 'Where is Sams Health Care located?',
    content:
      'Sams Health Care is proudly based in Pakistan, serving clients nationwide with high-quality Nutraceutical products.',
  },
];
const blogData = [
  {
    name : 'Sam Rose',
  
    one : 'High absorbancy of Iron',
    two : 'Fortified with Vitamins',
    three : 'Suitable for all ages',

    formulation : 'Ferrous Bisglycinate, Folic Acid & Vitamin C',
    title: 'The Benefits of Mindfulness Meditation for Stress and Anxiety',
    thumbUrl: 'images/home_1/pro1.jpeg',
    btnText: 'See Details',
    href: '/products/samrose',
    // socialShare: true,
  },
  {
    name : 'Samaf',
    formulation : 'Coral calcuim & Cholecalciferol ',
    
      one : 'Ostiopenia',
      two : 'Ostiaporosis',
      three : 'Pregnancy and lactation',
    
    title: 'Healthy Eating on a Budget: Tips and Strategies',

    thumbUrl: 'images/home_1/pro2.jpeg',
    btnText: 'See Details',
    href: '/products/samaf',
    // socialShare: true,
  },
  {
    name : 'S-TIG',
    formulation : 'Ace Men Formula',
      one : 'Enhances Male Fertility',
      two : ' Improves Vitality ',
      three : 'Improve Muscle Strength',
    title: 'The Importance of Regular Cancer Screenings and Early Detection',
    thumbUrl: 'images/home_1/pro3.jpeg',
    btnText: 'See Details',
    href: '/products/stig',
    // socialShare: true,
  },
  {
    name : 'KIASAM',
    formulation : 'Natural Acids',
      one : 'Fast Relief from Indigestion',
      two : 'Flatulance',
      three : 'Acidity & Heartburn',

    title: 'The Importance of Regular Cancer Screenings and Early Detection',
    thumbUrl: 'images/home_1/pro10.jpeg',
    btnText: 'See Details',
    href: '/products/kaisam',
    // socialShare: true,
  },
  {
    name : 'CALSAM-C',
    formulation : 'Instant Calcium with Vitamin C',
      one : 'Improves joint health ',
      two : 'Strengthens immune system ',
      three : 'Contributes to bone density',
    title: 'The Importance of Regular Cancer Screenings and Early Detection',
    thumbUrl: 'images/home_1/pro5.jpeg',
    btnText: 'See Details',
    href: '/products/calsam',
    // socialShare: true,
  },
  {
    name : 'Cran S',
    formulation : 'Cranberry Standardized Extract',      one : 'Anti-Adhesion',
      two : 'Ant-oxidant',
      three : 'Prevent Urinary Tract Infection',
    title: 'The Importance of Regular Cancer Screenings and Early Detection',
    thumbUrl: 'images/home_1/pro6.jpeg',
    btnText: 'See Details',
    href: '/products/cran',
    // socialShare: true,
  },
];
const awardData = [
  {
    title: 'Nutraceutical Manufacturing',
    subTitle:
      'Production of tablets, capsules, syrups, ointments, and more.',
    iconUrl: 'images/icons/award.svg',
  },
  {
    title: 'Custom Formulation Development',
    subTitle:
      'Tailored medicines to meet specific requirements.',
    iconUrl: 'images/icons/award.svg',
  },
  {
    title: 'Contract Manufacturing',
    subTitle:
      'Partnering with businesses to bring their Nutraceutical products to market.',
    iconUrl: 'images/icons/award.svg',
  },
  {
    title: 'Quality Control and Testing',
    subTitle:
      'Stringent testing processes to ensure the safety and efficacy of medicines.',
    iconUrl: 'images/icons/award.svg',
  },
];
const departmentData = [

  {
    title: 'Men',
    iconUrl: 'images/home_1/men.png',
    href: '/departments/department-details',
  },
  {
    title: 'Women',
    iconUrl: 'images/home_1/women.png',
    href: '/departments/department-details',
  },
  {
    title: '  Kids Health',
    iconUrl: 'images/home_1/boy.png',
    href: '/departments/department-details',
  },
  {
    title: '  Skin Care',
    iconUrl: 'images/home_1/skin.png',
    href: '/departments/department-details',
  },
  {
    title: '  Male Fertilization',
    iconUrl: 'images/home_1/fertilization.png',
    href: '/departments/department-details',
  },
  {
    title: '  Heart Health',
    iconUrl: 'images/home_1/heart.png',
    href: '/departments/department-details',
  },
  {
    title: '  Wieght Loss',
    iconUrl: 'images/home_1/loss.png',
    href: '/departments/department-details',
  },

  {
    title: '  Bones & Joints',
    iconUrl: 'images/home_1/broken-bone.png',
    href: '/departments/department-details',
  },
  {
    title: '  Immune Support',
    iconUrl: 'images/home_1/immunity.png',
    href: '/departments/department-details',
  },
  {
    title: 'Vitamins & Supplements',
    iconUrl: 'images/home_1/vitmins.png',
    href: '/departments/department-details',
  },
  {
    title: 'Specialized Formulations',
    iconUrl: 'images/home_1/formula.png',
    href: '/departments/department-details',
  },
  {
    title: 'Nutraceuticals',
    iconUrl: 'images/home_1/nutri.png',
    href: '/departments/department-details',
  },
  {
    title: ' Herbal Remedies',
    iconUrl: 'images/home_1/herbel.png',
    href: '/departments/department-details',
  },
  {
    title: 'Veterinary Care',
    iconUrl: 'images/home_1/veterinarya.png',
    href: '/departments/department-details',
  },
];

export default function Home() {
  pageTitle('Home');
  return (
    <>
      <Hero
        title="Your Trusted Partner in Quality Medicine Manufacturing"
        subTitle="Delivering Excellence in Nutraceuticals, Herbal Remedies, and Customized Healthcare Solutions."
        bgUrl="/images/home_1/herobg.jpg"
        imgUrl="/images/home_1/her.png"
        videoBtnText="See how we work"
        videoUrl="https://www.youtube.com/embed/VcaAVWtP48A"
        infoList={[
          {
            title: 'Phone',
            subTitle: '+92-300-7778809',
            iconUrl: '/images/contact/icon_1.svg',
          },
          {
            title: 'Email',
            subTitle: 'info@samhealthcarepk.com',
            iconUrl: '/images/icons/ambulance.svg',
          },
          {
            title: 'Location',
            subTitle: '0.5 km off Ferozepur Road, Mustafabad, Kasur',
            iconUrl: '/images/icons/pin.svg',
          },
        ]}
        btnText="Get a Qoute"
        btnUrl="/contact"
      />
         <Section topMd={185} topLg={150} topXl={110}>
        <DepartmentSection
          sectionTitle="Categories"
          bgUrl="images/home_1/hero_bg.jpg"
          data={departmentData}
        />
      </Section>
      {/* Start Feature Section */}
    
      <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={185}
        bottomLg={140}
        bottomXl={100}
      >
        {/* <FeaturesSection sectionTitle="Products"   data={featureListData} /> */}
        <Section topMd={190} topLg={145} topXl={105}>
        <BlogSection
          sectionTitle="Our Products"
          sectionTitleUp="Explore"
          data={blogData}
        />
      </Section>
      </Section>
      {/* End Feature Section */}
      {/* Start About Section */}
      <Section>
        <AboutSection
          imgUrl="/images/home_1/about.jpg"
          spiningImgUrl="/images/home_1/about_mini.svg"
          title="About Us"
          subTitle="SAMS HEALTH CARE"
          featureList={[
            {
              featureListTitle:
                'Welcome to Sams Health Care, a trusted leader in Nutraceutical manufacturing based in Pakistan.',
              featureListSubTitle:
                'At Sams Health Care, our state-of-the-art manufacturing facility adheres to the highest standards of safety and compliance, ensuring every product meets rigorous quality benchmarks.',
            },
          ]}
        />
      </Section>
      {/* End About Section */}
      {/* Start Departments Section */}
   

      {/* End Departments Section */}
      {/* Start Award Section */}
      <Section topMd={185} topLg={140} topXl={100}>
        <AwardSection sectionTitle="Services" data={awardData} />
      </Section>
      {/* End Award Section */}
      {/* Start Testimonial */}
      <Section
        topMd={185}
        topLg={140}
        topXl={100}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <TestimonialSection
          sectionTitle=" Reviews"
          sectionTitleDown="Of our clients"
        />
      </Section>
      {/* End Testimonial */}
      {/* Start Banner Section */}
      <Section>
        <Banner
          bgUrl="images/home_1/cta_bg.svg"
          imgUrl="images/home_1/h4.jpg"
          title="Prioritize Your Health with Our Comprehensive Services!"
          subTitle="Explore our wide range of healthcare solutions designed to meet your needs, delivered by experienced medical professionals!"
        />
      </Section>
      {/* End Banner Section */}
      {/* Start Blog Section */}
      {/* <Section topMd={190} topLg={145} topXl={105}>
        <BlogSection
          sectionTitle="Latest Update"
          sectionTitleUp="BLOG POSTS"
          data={blogData}
        />
      </Section> */}
      {/* End Blog Section */}
      {/* Start Appointment Section */}
      <Section topMd={190} topLg={145} topXl={105} id="appointment">
        <AppointmentSection
          sectionTitle="Contact Us"
          sectionTitleUp="We’d love to hear from you"
          imgUrl="/images/home_1/h2.jpg"
        />
      </Section>
      {/* End Appointment Section */}
      {/* Start FAQ Section */}
      <Section topMd={190} topLg={145} topXl={105}>
        <FaqSection
          data={faqData}
          sectionTitle="Usually Asked"
          sectionTitleUp="What People"
        />
      </Section>
      {/* End FAQ Section */}
      {/* Start Brand Section */}
      {/* <Section
        topMd={200}
        topLg={150}
        topXl={110}
        bottomMd={200}
        bottomLg={150}
        bottomXl={110}
      >
        <BrandsSection data={brandData} />
      </Section> */}
      {/* End Brand Section */}
    </>
  );
}
